import React from 'react';
import './App.css';
import App1 from './App1';
import Header from './component/Header';


const App = () => {
  return (
    <> 



          <App1/>
    </>

    
  )
}

export default App